import type { MemberItem } from "../types/member";

export const membersItems: MemberItem[] = [
  {
    id: "sugiyama",
    name: "杉山翔馬",
    image: "/assets/members/sugiyama.jpg",
    xUrl: "https://x.com/nazo_sugichan",
    handle: "@nazo_sugichan",
    description:
      "フリーの謎解きクリエイター。2023年末まで謎解き制作会社に在籍し、数多くの鉄道系周遊型謎解きを手がけた。フリー転身後はその豊富な制作経験とスキルを生かし、同人・企業問わず様々な団体に謎解きを提供している。",
  },
  {
    id: "shirukuto",
    name: "シルクト",
    image: "/assets/members/shirukuto.jpg",
    xUrl: "https://x.com/shirukuto_NAZO",
    handle: "@shirukuto_NAZO",
    description:
      "制作と緑色が大好きな謎解きクリエイター。持ち味のデザイン力や発想力を生かし、鉄道系周遊型謎解きや対面型謎解きなど、様々な種類のコンテンツを生み出してきた。現在も個人や所属団体で精力的に活動している。",
  },
  {
    id: "tomato",
    name: "とまと",
    image: "/assets/members/tomato.jpg",
    xUrl: "https://x.com/tomato_tryangle",
    handle: "@tomato_tryangle",
    description:
      "とまとが好きな謎解きクリエイター。SNSやメディア等で豊富な制作経験があり、様々な層が楽しめる謎解き制作を得意とする。エンジニアとしての一面もあり、このWebサイトの制作を担当した。",
  },
];
